export default __webpack_public_path__ + "static/media/hht1_ep03_timeline_q04_b.ca1d40cc.png";